<div class="progress" *ngIf="(channel.liveEPG$ | async)?.currentProgram">
  <div class="progress__start">{{ (channel.liveEPG$ | async)?.currentProgram?.start | momentp }}</div>
  <mat-progress-bar class="progress__bar" mode="determinate" [value]="progressValue"></mat-progress-bar>
  <div class="progress__end">{{ (channel.liveEPG$ | async)?.currentProgram?.end | momentp }}</div>
</div>
